import { Button, Box, Typography } from '@mui/material';
import { Icon24InfoMap, Icon24InfoErrands } from '@care/react-icons';
import { Dispatch, SetStateAction } from 'react';
import { StickyContainer } from '@care/react-component-lib';
import { trackAmplitudeEvent, AmplitudeEvent } from '@/lib/analyticsHelper';

interface ActivitiesMapCTAProps {
  showMap: boolean;
  setShowMap: Dispatch<SetStateAction<boolean>>;
}

const ActivitiesMapCTA = ({ showMap, setShowMap }: ActivitiesMapCTAProps) => {
  const listView = {
    ctaText: 'List view',
    ctaIcon: <Icon24InfoErrands />,
  };
  const mapView = {
    ctaText: 'Map',
    ctaIcon: <Icon24InfoMap />,
  };
  const cta = showMap ? listView : mapView;

  const handleCTAClick = () => {
    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, {
      cta_text: showMap ? 'List view' : 'Map',
    });

    setShowMap(!showMap);
  };

  return (
    <StickyContainer
      className={showMap ? 'show-map' : undefined}
      sx={{
        zIndex: 99,
        '&.show-map': {
          background: 'none',
        },
      }}>
      <Button
        variant="outlined"
        size="small"
        color="secondary"
        onClick={handleCTAClick}
        sx={{ px: 2, minHeight: '40px', width: 'auto' }}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Box pr={1} pt={1}>
            {cta.ctaIcon}
          </Box>
          <Typography component="span" variant="body1" textAlign="center">
            {cta.ctaText}
          </Typography>
        </Box>
      </Button>
    </StickyContainer>
  );
};

export { ActivitiesMapCTA };
